import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { get, isEmpty } from "lodash-es";
import { Badge, Empty, Spin } from "antd";
import moment from "moment";

const StoreSelectTable = (props) => {
  const localStorage = window.localStorage;
  const organizationID = localStorage.getItem("organizationID");

  const renderRowCard = (shop, selected) => {
    const id = get(shop, "id", "-");
    const name = get(shop, "name", "-");
    const createdAt = get(shop, "created_at");
    const active = get(shop, "active", false);
    const createdDate = createdAt ? moment(createdAt).format("LL") : "-";

    return (
      <div className="row-card" key={id}>
        <div className="shop-info">
          <div className="left">
            <div className="name">{name}</div>
            <div className="created-at">created at: {createdDate}</div>
          </div>
          <div className="right">
            <Badge status={active ? "success" : "error"} text={active ? "Active" : "Inactive"} />
          </div>
        </div>
        <div
          className={`selectButton ${selected && "selected"} ${!active && "disabled"}`}
          onClick={active ? () => props.onSelectShop(shop) : () => {}}
        >
          Select
        </div>
      </div>
    );
  };

  const renderShopRows = () => {
    if (props.loading) {
      return (
        <div className="loading-stores">
          <Spin />
        </div>
      );
    }

    const selectedShopID = get(props.selectedShop, "id");
    const rows = props.shops && props.shops.map((shop) => renderRowCard(shop, shop.id === selectedShopID));

    if (isEmpty(rows)) {
      const message = (
        <span className="no-store-found-msg">
          No stores found, try <Link to={`/organizations/${organizationID}/stores`}>Configure store</Link>
        </span>
      );

      return (
        <div className="no-store-found">
          <Empty description={message} />
        </div>
      );
    }

    return rows;
  };

  return (
    <div className="store-select-table">
      <div className="title">Your Shopify Stores</div>
      {renderShopRows()}
    </div>
  );
};

StoreSelectTable.propTypes = {
  selectedShop: PropTypes.object,
  onSelectShop: PropTypes.func.isRequired,
  shops: PropTypes.array,
  loading: PropTypes.bool,
};

export default StoreSelectTable;
